import React, { Component } from 'react';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

import CreateItem from '../../../../Common/Partials/CreateItem';
import CreativeSettingsHome from './CreativeSettingsHome';
import CreativeSettingsSource from './CreativeSettingsSource';
import CreativeSettingsDetails from './CreativeSettingsDetails';
import CreativeSettingsRtb from './CreativeSettingsRtb';

type Props = {
  fields: any,
  record: any
};

type StateProps = {
  value: number
};

class CreativeSettings extends Component<Props, StateProps> {
  state = { value: 0 };

  handleChange = (event, value) => {
    this.setState({ value });
  };

  render() {
    return (
      <div>
        {this.props.fields.map((item, index) => {
          const field = this.props.fields.get(index);
          if (field && field._destroy) {
            return false
          }

          return (
            <div key={index}>
              <div style={{ border: '1px solid rgba(0, 0, 0, 0.1)', padding: 25 }}>
                <AppBar position="static">
                  <Tabs value={this.state.value} onChange={this.handleChange}>
                    <Tab label="Home" />
                    <Tab label="Source" />
                    <Tab label="Details" />
                    <Tab label="RTB" />
                  </Tabs>
                </AppBar>
                {this.state.value === 0 &&
                  <CreativeSettingsHome item={item} record={this.props.record} index={index} />}
                {this.state.value === 1 &&
                  <CreativeSettingsSource item={item} record={this.props.record} index={index} />}
                {this.state.value === 2 &&
                  <CreativeSettingsDetails item={item} />}
                {this.state.value === 3 &&
                  <CreativeSettingsRtb item={item} index={index} />}
              </div><br /><br />
            </div>
          )
        })}
        <div style={{ paddingTop: 20 }}>
          <CreateItem fields={this.props.fields} label="Add Creative" />
        </div>
      </div>
    )
  }
};

export default CreativeSettings;



// WEBPACK FOOTER //
// ./src/views/Components/Campaigns/Site/Partials/CreativeSettings.tsx